import { render, staticRenderFns } from "./clientpersupplier.vue?vue&type=template&id=9c5c0d00&"
import script from "./clientpersupplier.vue?vue&type=script&lang=js&"
export * from "./clientpersupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports